import { Popup } from '@jojo-design/mobile';
import React from 'react';

import loadingIcon from '../../public/assets/images/payresult.gif';
import S from './index.less';

interface IProps {
  visible: boolean;
  onMaskClick?: () => void;
  maskStyle?: any;
  desc?: string;
  text?: string;
  zIndex?: string;
}

const Loading = (props: IProps) => {
  const { visible, maskStyle, onMaskClick, desc = '', text = '加载中', zIndex = '990' } = props;
  return (
    <Popup
      visible={visible}
      onMaskClick={() => {
        onMaskClick?.();
      }}
      maskStyle={maskStyle}
      hasEnterAnimated={false}
      position='center'
      style={{ '--z-index': zIndex }}
      bodyStyle={{ background: 'none' }}>
      <div className={S.loadingWrapper}>
        <div className={S.loadingContainer}>
          <img src={loadingIcon} alt='' className={S.loadingIcon} />
          <div className={S.loadingText}>{text}</div>
          {desc ? <div className={S.loadingSubText}>{desc}</div> : null}
        </div>
      </div>
    </Popup>
  );
};

export default Loading;
